import { observer } from 'mobx-react-lite'
import './lib/loading-bar.min.css'
import './lib/loading-bar.min.js'
import './loading-bar.scss'
import { storeAPI } from '@Stores/StoreAPI.js'
import { useEffect, useLayoutEffect, useRef, useState } from 'react'
import { getQueryString } from '@Configs/ConfigsHeader'
import { autorun, reaction } from 'mobx'
import StoreMenu from '@Stores/StoreMenu'
const LoadingBar = observer(props => {
    // ${storeAPI.IsApiLoaded() >= 100 ? 'fade-out' : ''}
    const [loading, setLoading] = useState(true)
    const [loaded, setLoaded] = useState(false)

    useEffect(() => {
      

        autorun(r => {
            if(storeAPI.IsCoreReady && storeAPI.GetPercentSummary()>=100 && StoreMenu.isInitialized) {
                setLoaded(true)
                setTimeout(() => {
                    setLoading(false)
                    r.dispose()
                }, 500)
            }
        })

        reaction(
            () => storeAPI.IsMainApiLoaded.country,
            (n,p,r) => {
                
                if(n === true && window.location.pathname === '/') {
                    setLoaded(true)
                    setLoading(false)
                    r.dispose()
                }
            }
        )

    }, [])

    return (
        <div className={`loading-bar-wrapper ${loading === false ? 'fade-out' : ''}`} style={{ width: window.innerWidth, height: window.innerHeight }}>
            <GradientLoader value={loaded === false ? (storeAPI.GetPercentSummary() > 95 ? 95 : storeAPI.GetPercentSummary()) : 100} />
        </div>
    )
})

const GradientLoader = ({ value }) => {
    const [barInstance, setBarInstance] = useState(null)
    const [color1, setColor1] = useState(getQueryString().color1 ? getQueryString().color1 : '05d7fc')
    const [color2, setColor2] = useState(getQueryString().color2 ? getQueryString().color2 : '0f0f0f')
    const barRef = useRef()

    useLayoutEffect(() => {
        if (barRef.current) {
            if (barInstance === null) {
                setBarInstance(
                    new ldBar('.ldBar', {
                        value: value
                    })
                )
            } else {
                barInstance.set(value, true)
            }
        }
    }, [barRef.current, value, color1, color2])

    useLayoutEffect(() => {
        if (getQueryString().color1 && getQueryString().color2) {
            setColor1(getQueryString().color1)
            setColor2(getQueryString().color2)
        }
    }, [getQueryString().color1, getQueryString().color2])

    return <div className="ldBar" ref={barRef} style={{ width: '100%', height: 40 }} data-img-size="500,100" data-stroke={`data:ldbar/res,gradient(0,1,#${color1},#${color2})`} />
}

const StripeLoader = ({ value }) => {
    const [barInstance, setBarInstance] = useState(null)
    const [color1, setColor1] = useState(getQueryString().color1 ? getQueryString().color1 : '05d7fc')
    const [color2, setColor2] = useState(getQueryString().color2 ? getQueryString().color2 : '0f0f0f')
    const barRef = useRef()

    useLayoutEffect(() => {
        if (barRef.current) {
            if (barInstance === null) {
                setBarInstance(
                    new ldBar('.ldBar', {
                        value: value
                    })
                )
            } else {
                barInstance.set(value, true)
            }
        }
    }, [barRef.current, value, color1, color2])

    useLayoutEffect(() => {
        if (getQueryString().color1 && getQueryString().color2) {
            setColor1(getQueryString().color1)
            setColor2(getQueryString().color2)
        }
    }, [getQueryString().color1, getQueryString().color2])

    return <div className="ldBar" ref={barRef} style={{ width: '100%', height: 40 }} data-img-size="500,100" data-stroke={`data:ldbar/res,stripe(#${color1},#${color2},1)`} />
}

export default LoadingBar
